// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__kFp1h","left":"styles_left__1Byir","right":"styles_right__3qEqX","alert":"styles_alert__1EMPy"};